import { PerPeriod }  from './per-period';
export default PerPeriod;


